import React from "react";

export default function Menu({ children, className }) {
  return <menu className={className}>{children}</menu>;
}
